import { createAction } from '@ngrx/store';

export const allDataWasLoaded = createAction(
  '[SP_ALL] All Data was loaded',
);
